import { CalculationKeynameEnum } from '../../../../../../../common/src/enums/calculations/calculation-keyname.enum';
import { property } from '@pristine-ts/metadata';
import { v4 as uuid } from 'uuid';

export class QuickCalculationCacheModel {
  @property()
  id: string = uuid();

  @property()
  type: CalculationKeynameEnum;

  @property()
  updatedAt: Date;

  @property()
  title: string;

  @property()
  options: any;

  @property()
  results: any;
}
